import { apiRequest } from '../core';

export function GetCategoriesList() {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/GetCategoriesListByPopup`);
  return apiRequest(url);
}

export function GetTopicsByCategory(categoryAlias, take, skip) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/topics/${categoryAlias}`);

  const params = {};
  if (take) {
    params.take = take;
  }
  if (skip) {
    params.skip = skip;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}

export function GetForumBlockData() {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/GetForumBlockData`);
  return apiRequest(url);
}

export function GetMainPage() {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/GetMainPage`);
  return apiRequest(url);
}

export function GetTopic(alias) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/topic/${alias}`);
  return apiRequest(url);
}

export function GetComments(topicId, take, skip) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/comments/${topicId}`);

  const params = {};
  if (take) {
    params.take = take;
  }
  if (skip) {
    params.skip = skip;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}

export function CreateTopic(model) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/CreateTopic`);
  return apiRequest(url, {
    method: 'POST',
    credentials: 'same-origin',
    body: model,
  });
}

export function CreateComment(comment) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/CreateComment`);
  return apiRequest(url, {
    method: 'POST',
    credentials: 'same-origin',
    body: comment,
  });
}

export function ForumSearch(query, searchType, alias, take, skip) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Forum/search/${query}/${searchType}`);

  const params = {};
  if (alias) {
    params.alias = alias;
  }
  if (take) {
    params.take = take;
  }
  if (skip) {
    params.skip = skip;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}
